import { ManufacturingLifecycleStatus } from '../../constants/manufacturing-lifecycle-status.js';
/** The two statuses a work order, line or order can no longer move out of — the ladder's rules 1 and 2. */
export const MANUFACTURING_TERMINAL_STATUS_IDS = [
    ManufacturingLifecycleStatus.COMPLETED,
    ManufacturingLifecycleStatus.CANCELLED,
];
//# sourceMappingURL=terminal-status-ids.js.map